import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, AlertCircle, BarChart3, Network, FileText, Settings, LogOut } from 'lucide-react';
interface SidebarProps {
  isOpen: boolean;
  isCollapsed: boolean;
  onClose: () => void;
}
const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  isCollapsed,
  onClose
}) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    navigate('/login');
  };
  const menuItems = [{
    to: '/',
    icon: LayoutDashboard,
    label: 'Overview',
    end: true
  }, {
    to: '/strategic-dashboard',
    icon: AlertCircle,
    label: 'Strategic Dashboard'
  }, {
    to: '/ibrief',
    icon: FileText,
    label: 'iBRIEF'
  }, {
    to: '/performance',
    icon: BarChart3,
    label: 'Performance Cockpit'
  }];
  const additionalItems = [{
    to: '/cases',
    icon: Network,
    label: 'Cases & Alerts'
  }, {
    to: '/settings',
    icon: Settings,
    label: 'Settings & Access'
  }];
  return <>
      {/* Desktop Sidebar */}
      <div className={`hidden lg:flex flex-col bg-gradient-to-b from-[#0F1419] to-[#0A0E17] border-r border-gray-800/50 backdrop-blur-xl transition-all duration-300 ease-in-out ${isCollapsed ? 'w-20' : 'w-72'} relative z-40 flex-shrink-0`} data-id="element-66">
        {/* Logo Section */}
        <div className="p-4 border-b border-gray-800/50 flex-shrink-0" data-id="element-67">
          <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'}`} data-id="element-68">
            <div className="relative flex-shrink-0" data-id="element-69">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9NrYJzdqEfnhGEe7xtwXX4/Logo_BIN_NEW.png" alt="BIN Logo" className={`transition-all duration-300 ${isCollapsed ? 'h-10 w-10' : 'h-12 w-12'}`} data-id="element-70" />
              <div className="absolute inset-0 bg-cyan-500/20 blur-xl rounded-full" data-id="element-71"></div>
            </div>
            {!isCollapsed && <div className="transition-opacity duration-300 min-w-0" data-id="element-72">
                <h1 className="text-lg font-bold text-white bg-gradient-to-r from-white to-cyan-400 bg-clip-text text-transparent truncate" data-id="element-73">
                  NEXUS BIN
                </h1>
                <p className="text-xs text-gray-400 truncate" data-id="element-74">
                  Executive Intelligence Console
                </p>
              </div>}
          </div>
        </div>
        {/* Navigation */}
        <nav className="flex-1 pt-6 px-3 overflow-y-auto overflow-x-hidden" data-id="element-75">
          <div className="space-y-1" data-id="element-76">
            {menuItems.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
            isActive
          }) => `flex items-center ${isCollapsed ? 'justify-center px-3' : 'px-4'} py-3 rounded-xl transition-all duration-200 group relative ${isActive ? 'bg-gradient-to-r from-cyan-600/20 to-blue-600/20 text-white border border-cyan-500/30 shadow-lg shadow-cyan-500/10' : 'text-gray-400 hover:bg-gray-800/50 hover:text-white'}`} data-id="element-77">
                {({
              isActive
            }) => <>
                    {isActive && <div className="absolute left-0 w-1 h-8 bg-gradient-to-b from-cyan-500 to-blue-500 rounded-r-full" data-id="element-78"></div>}
                    <item.icon className={`${isCollapsed ? '' : 'mr-3'} h-5 w-5 transition-transform group-hover:scale-110 flex-shrink-0`} data-id="element-79" />
                    {!isCollapsed && <span className="font-medium truncate" data-id="element-80">{item.label}</span>}
                    {isCollapsed && <div className="absolute left-full ml-6 px-3 py-2 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap z-50 border border-gray-700 shadow-xl" data-id="element-81">
                        {item.label}
                      </div>}
                  </>}
              </NavLink>)}
          </div>
          <div className={`${isCollapsed ? 'px-3' : 'px-4'} py-3 mt-6`} data-id="element-82">
            <div className={`text-xs uppercase text-gray-500 font-semibold tracking-wider ${isCollapsed ? 'text-center' : ''}`} data-id="element-83">
              {isCollapsed ? '•••' : 'Additional Modules'}
            </div>
          </div>
          <div className="space-y-1" data-id="element-84">
            {additionalItems.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `flex items-center ${isCollapsed ? 'justify-center px-3' : 'px-4'} py-3 rounded-xl transition-all duration-200 group relative ${isActive ? 'bg-gradient-to-r from-cyan-600/20 to-blue-600/20 text-white border border-cyan-500/30 shadow-lg shadow-cyan-500/10' : 'text-gray-400 hover:bg-gray-800/50 hover:text-white'}`} data-id="element-85">
                {({
              isActive
            }) => <>
                    {isActive && <div className="absolute left-0 w-1 h-8 bg-gradient-to-b from-cyan-500 to-blue-500 rounded-r-full" data-id="element-86"></div>}
                    <item.icon className={`${isCollapsed ? '' : 'mr-3'} h-5 w-5 transition-transform group-hover:scale-110 flex-shrink-0`} data-id="element-87" />
                    {!isCollapsed && <span className="font-medium truncate" data-id="element-88">{item.label}</span>}
                    {isCollapsed && <div className="absolute left-full ml-6 px-3 py-2 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap z-50 border border-gray-700 shadow-xl" data-id="element-89">
                        {item.label}
                      </div>}
                  </>}
              </NavLink>)}
          </div>
        </nav>
        {/* User Section */}
        <div className="p-4 border-t border-gray-800/50 mt-auto flex-shrink-0" data-id="element-90">
          {!isCollapsed && <div className="flex items-center space-x-3 mb-3 px-2 min-w-0" data-id="element-91">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center text-white font-semibold shadow-lg flex-shrink-0" data-id="element-92">
                K
              </div>
              <div className="flex-1 min-w-0" data-id="element-93">
                <p className="text-sm font-medium text-white truncate" data-id="element-94">
                  Kepala BIN
                </p>
                <p className="text-xs text-gray-400 truncate" data-id="element-95">Secure Access</p>
              </div>
            </div>}
          <button onClick={handleLogout} className={`w-full flex items-center ${isCollapsed ? 'justify-center px-3' : 'px-4'} py-2.5 bg-red-900/20 hover:bg-red-900/30 text-red-400 rounded-xl border border-red-800/30 transition-all duration-200 group`} data-id="element-96">
            <LogOut className={`${isCollapsed ? '' : 'mr-2'} h-4 w-4 transition-transform group-hover:scale-110 flex-shrink-0`} data-id="element-97" />
            {!isCollapsed && <span className="text-sm font-medium truncate" data-id="element-98">Logout</span>}
          </button>
        </div>
      </div>
      {/* Mobile Sidebar */}
      <div className={`fixed inset-y-0 left-0 w-72 bg-gradient-to-b from-[#0F1419] to-[#0A0E17] border-r border-gray-800/50 backdrop-blur-xl transform transition-transform duration-300 ease-in-out z-40 lg:hidden ${isOpen ? 'translate-x-0' : '-translate-x-full'} flex flex-col`} data-id="element-99">
        {/* Logo Section */}
        <div className="p-4 border-b border-gray-800/50 flex-shrink-0" data-id="element-100">
          <div className="flex items-center space-x-3" data-id="element-101">
            <div className="relative flex-shrink-0" data-id="element-102">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9NrYJzdqEfnhGEe7xtwXX4/Logo_BIN_NEW.png" alt="BIN Logo" className="h-12 w-12" data-id="element-103" />
              <div className="absolute inset-0 bg-cyan-500/20 blur-xl rounded-full" data-id="element-104"></div>
            </div>
            <div className="min-w-0" data-id="element-105">
              <h1 className="text-lg font-bold text-white bg-gradient-to-r from-white to-cyan-400 bg-clip-text text-transparent truncate" data-id="element-106">
                NEXUS BIN
              </h1>
              <p className="text-xs text-gray-400 truncate" data-id="element-107">
                Executive Intelligence Console
              </p>
            </div>
          </div>
        </div>
        {/* Navigation */}
        <nav className="flex-1 pt-6 px-3 overflow-y-auto overflow-x-hidden" data-id="element-108">
          <div className="space-y-1" data-id="element-109">
            {menuItems.map(item => <NavLink key={item.to} to={item.to} end={item.end} onClick={onClose} className={({
            isActive
          }) => `flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative ${isActive ? 'bg-gradient-to-r from-cyan-600/20 to-blue-600/20 text-white border border-cyan-500/30 shadow-lg shadow-cyan-500/10' : 'text-gray-400 hover:bg-gray-800/50 hover:text-white'}`} data-id="element-110">
                {({
              isActive
            }) => <>
                    {isActive && <div className="absolute left-0 w-1 h-8 bg-gradient-to-b from-cyan-500 to-blue-500 rounded-r-full" data-id="element-111"></div>}
                    <item.icon className="mr-3 h-5 w-5 transition-transform group-hover:scale-110 flex-shrink-0" data-id="element-112" />
                    <span className="font-medium truncate" data-id="element-113">{item.label}</span>
                  </>}
              </NavLink>)}
          </div>
          <div className="px-4 py-3 mt-6" data-id="element-114">
            <div className="text-xs uppercase text-gray-500 font-semibold tracking-wider" data-id="element-115">
              Additional Modules
            </div>
          </div>
          <div className="space-y-1" data-id="element-116">
            {additionalItems.map(item => <NavLink key={item.to} to={item.to} onClick={onClose} className={({
            isActive
          }) => `flex items-center px-4 py-3 rounded-xl transition-all duration-200 group relative ${isActive ? 'bg-gradient-to-r from-cyan-600/20 to-blue-600/20 text-white border border-cyan-500/30 shadow-lg shadow-cyan-500/10' : 'text-gray-400 hover:bg-gray-800/50 hover:text-white'}`} data-id="element-117">
                {({
              isActive
            }) => <>
                    {isActive && <div className="absolute left-0 w-1 h-8 bg-gradient-to-b from-cyan-500 to-blue-500 rounded-r-full" data-id="element-118"></div>}
                    <item.icon className="mr-3 h-5 w-5 transition-transform group-hover:scale-110 flex-shrink-0" data-id="element-119" />
                    <span className="font-medium truncate" data-id="element-120">{item.label}</span>
                  </>}
              </NavLink>)}
          </div>
        </nav>
        {/* User Section */}
        <div className="p-4 border-t border-gray-800/50 flex-shrink-0" data-id="element-121">
          <div className="flex items-center space-x-3 mb-3 px-2 min-w-0" data-id="element-122">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center text-white font-semibold shadow-lg flex-shrink-0" data-id="element-123">
              K
            </div>
            <div className="flex-1 min-w-0" data-id="element-124">
              <p className="text-sm font-medium text-white truncate" data-id="element-125">
                Kepala BIN
              </p>
              <p className="text-xs text-gray-400 truncate" data-id="element-126">Secure Access</p>
            </div>
          </div>
          <button onClick={handleLogout} className="w-full flex items-center justify-center px-4 py-2.5 bg-red-900/20 hover:bg-red-900/30 text-red-400 rounded-xl border border-red-800/30 transition-all duration-200 group" data-id="element-127">
            <LogOut className="mr-2 h-4 w-4 transition-transform group-hover:scale-110 flex-shrink-0" data-id="element-128" />
            <span className="text-sm font-medium" data-id="element-129">Logout</span>
          </button>
        </div>
      </div>
    </>;
};
export default Sidebar;